<div fxLayout="column" id="login">
  <div fxLayout="column" fxLayoutAlign="center center" id="login-form-wrapper">
    <div id="login-form" [@animateStagger]="{ value: '50' }">
      <div *ngIf="logoUrl" class="logo">
        <img
          alt="logo"
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [src]="logoUrl"
        />
      </div>

      <div class="title" [@animate]="{ value: '*', params: { x: '-50px' } }">
        {{ titleText }}
      </div>

      <form
        name="loginForm"
        novalidate
        [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }"
        [formGroup]="loginForm"
      >
        <mat-form-field
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [appearance]="appearance"
        >
          <input
            formControlName="email"
            matInput
            autocomplete="username"
            [placeholder]="emailText"
          />
          <mat-icon matSuffix [color]="color">email</mat-icon>
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            {{ emailErrorRequiredText }}
          </mat-error>
          <mat-error
            *ngIf="
              !loginForm.get('email')?.hasError('required') &&
              loginForm.get('email')?.hasError('email')
            "
          >
            {{ emailErrorPatternText }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          [@animate]="{ value: '*', params: { x: '50px' } }"
          [appearance]="appearance"
        >
          <input
            formControlName="password"
            matInput
            type="password"
            autocomplete="current-password"
            [placeholder]="passwordText"
          />
          <mat-icon matSuffix [color]="color">lock</mat-icon>
          <mat-error>
            {{ passwordErrorRequiredText }}
          </mat-error>
        </mat-form-field>

        <div
          class="remember-forgot-password"
          fxLayout="row"
          fxLayout.xs="column"
          fxLayoutAlign="space-between center"
          [@animate]="{ value: '*', params: { x: '50px' } }"
        >
          <button
            *ngIf="resetPasswordEnabled"
            class="forgot-password"
            mat-button
            type="button"
            [@animate]="{ value: '*', params: { x: '-50px' } }"
            [color]="color"
            (click)="onResetPasswordRequested.emit()"
          >
            {{ forgotPasswordText }}
          </button>
        </div>

        <button
          aria-label="LOG IN"
          class="submit-button"
          id="loginButton"
          mat-raised-button
          [color]="colorAccent"
          [disabled]="loginForm.invalid"
          (click)="login()"
        >
          {{ loginButtonText }}
        </button>
      </form>

      <div
        *ngIf="providers.length > 0"
        class="separator"
        [@animate]="{
          value: '*',
          params: { z: '50px', delay: '50ms', scale: '0.2' }
        }"
      >
        <span class="text">{{ orLabelText }}</span>
      </div>

      <pt-auth-providers
        fxLayoutAlign="center center"
        [layout]="layout"
        [theme]="theme"
        [providers]="providers"
      />

      <div
        *ngIf="registrationEnabled"
        class="register"
        fxLayout="column"
        fxLayoutAlign="center center"
        [@animateStagger]="{ value: '100' }"
      >
        <span class="text" [@animate]="{ value: '*', params: { x: '100px' } }">
          {{ dontHaveAnAccountText }}
        </span>
        <button
          id="createAccountButton"
          mat-button
          type="button"
          [@animate]="{ value: '*', params: { x: '-100px' } }"
          [color]="color"
          (click)="onCreateAccountRequested.emit()"
        >
          {{ createAccountButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
